import { styled } from '@mui/material'
import { Box } from 'presentation/components/atoms/box'

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: 32,
}))
